import React from "react";
import { useIntl } from "react-intl";

import { Equation } from "@learningblocks/protocol-components/lib/Equation";

import { TableCellProps } from "../types";
import { mathJaxCellClass } from "../TableQuestion.css";

export type MathJaxCellProps = Pick<
  TableCellProps,
  "cellId" | "text" | "colspan" | "ariaLabel"
>;

export const MathJaxCell: React.FC<MathJaxCellProps> = ({
  cellId,
  text,
  colspan,
  ariaLabel,
}) => {
  const intl = useIntl();

  const translatedText = text
    ? intl.formatMessage({ id: text, defaultMessage: text })
    : "";

  const translatedAriaLabel = ariaLabel
    ? intl.formatMessage({ id: ariaLabel, defaultMessage: ariaLabel })
    : undefined;

  const renderContent = () => {
    if (!translatedText) return null;
    return <Equation text={translatedText} />;
  };

  return (
    <td
      key={cellId}
      className={mathJaxCellClass}
      colSpan={colspan ? Number(colspan) : undefined}
      aria-label={translatedAriaLabel}
    >
      {renderContent()}
    </td>
  );
};
